import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=6a870488&scoped=true&"
import script from "./FileDownload.vue?vue&type=script&lang=js&"
export * from "./FileDownload.vue?vue&type=script&lang=js&"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=6a870488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a870488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
